import React, { useEffect, useState, useCallback } from "react";
import { Layout, Row, Col } from "antd";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import { FaBatteryFull, FaBatteryThreeQuarters, FaBatteryHalf, FaBatteryQuarter, FaBatteryEmpty, FaThermometerHalf, FaTint, FaBars } from 'react-icons/fa';

// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import RuntimeConfigsApi from "../../common/Apis/RuntimeConfigsApi";
const SensorDashboard = () => {
  const navigate = useNavigate();
  const { Content } = Layout;

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const SensorApi = localStorage.getItem("SensorApi");

  let isSUPER_ADMIN = false;
  const [StorageInst, setStorage] = React.useState([]);

  function convertTimestamp(dateString) {
    const dateObject = new Date(dateString);

    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };

    const formattedDate = `Last updated ${dateObject.toLocaleTimeString('en-US', options)}`;
    return formattedDate;
  }
  const BatteryIcon = ({ percentage }) => {
    let IconComponent;

    if (percentage >= 75) {
      IconComponent = <FaBatteryFull style={{ fontSize: '20px' }} />;
    } else if (percentage >= 50) {
      IconComponent = <FaBatteryThreeQuarters style={{ fontSize: '20px' }} />;
    } else if (percentage >= 25) {
      IconComponent = <FaBatteryHalf style={{ fontSize: '20px' }} />;
    } else if (percentage > 0) {
      IconComponent = <FaBatteryQuarter style={{ fontSize: '20px' }} />;
    } else {
      IconComponent = <FaBatteryEmpty style={{ fontSize: '20px' }} />;
    }

    return IconComponent;
  };
  const BatteryIndicator = ({ percentage }) => (
    <div>
      <BatteryIcon percentage={percentage} />
    </div>
  );
  const [isLoading, setIsLoading] = useState(false);

  const getRuntimeConfigs = useCallback(() => {
    RuntimeConfigsApi.ListRuntimeConfigs()
      .then((response) => {
        console.log(response.payloadDto.filter(item => item?.tag === 'SENSOR_API_CONFIG'))
        let url = `https://api.sync-sign.com/v2/oauth/token`;
        if (response.payloadDto.filter(item => item?.tag === 'SENSOR_API_CONFIG')?.length === 0) {
          setIsLoading(false);
        }
        axios
          .post(url, {
            "username": (response.payloadDto.filter(item => item?.tag === 'SENSOR_API_CONFIG' && item?.configKey === 'USER_NAME')[0]?.configValue),
            "password": (response.payloadDto.filter(item => item?.tag === 'SENSOR_API_CONFIG' && item?.configKey === 'PASSWORD')[0]?.configValue),
            "provider": (response.payloadDto.filter(item => item?.tag === 'SENSOR_API_CONFIG' && item?.configKey === 'PROVIDER')[0]?.configValue)

          })
          .then((res) => {
            localStorage.setItem("SensorApi", res?.data?.data?.accessToken);
            let headers = {
              Authorization: `Bearer ${res?.data?.data?.accessToken}`,
              "accept": `application/json`,
            };
            let url2 = `https://api.sync-sign.com/v2/nodes`;
            axios
              .get(url2, {
                headers: headers,
              })
              .then((res2) => {
                console.log(res2?.data)
                setIsLoading(false);
                setStorage(res2?.data?.data)
              })
              .catch((err) => {
                console.log(err);

              });
          })
          .catch((err) => {
            console.log(err);

          });

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  const getStorageInstruction = useCallback(async () => {
    if (!SensorApi) {
      setIsLoading(true);
      getRuntimeConfigs();
    } else {
      let headers = {
        Authorization: `Bearer ${SensorApi}`,
        "accept": `application/json`,
      };
      let url2 = `https://api.sync-sign.com/v2/nodes`;
      axios
        .get(url2, {
          headers: headers,
        })
        .then((res2) => {
          console.log(res2?.data)
          setIsLoading(false);
          setStorage(res2?.data?.data)
        })
        .catch((err) => {
          console.log(err);

        });
    }

  }, []);

  const [RuntimeConfigs, setRuntimeConfigs] = React.useState([]);
  const getStorage = useCallback(() => {
    RuntimeConfigsApi.ListRuntimeConfigs()
      .then((response) => {
        setRuntimeConfigs(response.payloadDto.filter(item => item?.tag === 'SENSOR_API_CONFIG'));
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getStorageInstruction();
    getRuntimeConfigs();
    getStorage();
  }, [getStorageInstruction, getStorage, getRuntimeConfigs]);
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout style={{ width: "100%" }}>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <Content style={{ margin: "14px 16px 0", display: 'flex', justifyContent: 'center' }}>
          <Row gutter={12} style={{ width: "80%" }}>
            <Col
              lg={24}
              md={24}
              className={RuntimeConfigs.length === 0 ? "pt-3" : "d-none"}
            > <p style={{ fontSize: '17px' }}>You need to set the API credentials from <Link to={'https://portal.mocreo.com/'} target="_blank">Mocreo</Link>. if you already have them please update <Link to={'/settings/sensor-configurations'}>here</Link>.</p>
            </Col>


            {(StorageInst && RuntimeConfigs.length !== 0) && <>
              {
                StorageInst.map((item) => (
                  <>
                    <Col
                      lg={12}
                      md={12}
                      className="pt-3"
                    >
                      <div >
                        <div className={item?.onlined === true ? 'SensorDiv AlertNotificationNew ' : 'SensorDiv AlertNotificationNew AlertNotificationNew2'} style={{ width: "100%" }}>
                          <div className="container">
                            <div className="text top-left"><p className="mb-0 pb-0" style={{ fontWeight: '500', fontSize: '22px' }}>{item?.nodeId}</p>{item?.onlined === true ? <><FaThermometerHalf style={{ color: '#00a18b' }} /> 0 'C &nbsp;&nbsp;<FaTint style={{ color: '#00a18b' }} /> 0 'C</> : <><FaThermometerHalf style={{ color: '#00a18b' }} /> 0 'C &nbsp;&nbsp;<FaTint style={{ color: '#00a18b' }} /> 0 'C </>}</div>
                            <div className="text top-right">{item?.onlined === true ? <><BatteryIndicator percentage={item?.batteryLevel} />&nbsp;&nbsp;<FaBars style={{ color: '#00a18b', fontSize: '17px' }} /></> : 'Device Offline'}</div>
                            <div className="text bottom-left"></div>
                            <div className="text bottom-right">{convertTimestamp(item?.updatedAt)}</div>
                          </div>
                        </div>
                      </div>
                    </Col>

                  </>
                ))
              }
            </>
            }

          </Row>

        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout >
  );
};

export default SensorDashboard;
